import { Button } from "antd";
import styled, { keyframes } from "styled-components";

const containerPadding = 20; //Ajuste conforme necessário para preenchimento no FieldContainer

const bgColorPadrao = "#0361a7";
const bgColorHover = "rgb(2, 80, 140)";
const bgColorFocus = "rgb(1, 60, 120)";
const bgColorWhite = "#ffffff";
const bgColorGray = "#aeaeae";
const bgColorGreen = "rgb(63, 134, 0)";
const bgColorGreenAdd = "#07bc0c";

const colorWhite = "#fff";
const colorGray = "#706f6f";
const colorGreen = "#198754";

const boxShadowStandard =
  "rgb(251 251 251 / 50%) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px;"; // aqui vai ser o box-shadon padrão do inglês Standard


  const titleInput = `
  color: ${bgColorPadrao};
  font-weight: 700;
  font-size: 12px;
`;

//Esse componente vai servir para colocar o icone dentro do input, seja ele o icon de calendario ou busca, qual for.
export const FieldGlyph = styled.div`
    font-size: 24px;
    text-align: center;
    position: relative;
    top: -30px;
    left: -16px;
    width: 37px;
    float: right;
`;

export const FieldContainerDate  = styled.div`
  padding: 0;
  width: 100%;

  .fieldTitle {
    position: relative;
    top: 15px;
    right: 10px;
    color: #727272;
  }

  .paddingSpace{
  padding:10px;
  width: 200px;
  }
`;

//Usar os 3 components para colocar um input type text
export const FieldContainer = styled.div`
  display: flex;
  padding: ${containerPadding}px 0;

  .msgFilterSearch {
    width: 700px;
  }

  .inputDate {
    width: 200px;
    margin-left: 5px;
    position: relative;
    top: -14px;
  }

  .inputSelect {
    width: 225px;
    padding: 0px;
    height: 46px;
    margin: 3px 5px;
  }

  @media only screen and (max-width: 500px) {
    display: ruby-text;
  }
`;

export const InputFieldContainer = styled.div`
  padding: 5px 0;
  width: 100%;

  .fieldTitle {
    position: relative;
    top: 15px;
    right: 10px;
    color: #727272;
  }

  .fontSize {
    font-size: 12px;
  }

  .select-styled {
    width: 225px;
    height: 45px;
    border: none;
    border-radius: 8px;
    padding: 0 10px;
    color: #696969;
    outline: none;
  }
  .select-styled:hover {
    border: 1px solid #219fff;
  }
  .select-styled:focus {
    border: none;
    outline: none;
    box-shadow: none;
  }

  .display-flex {
    display: flex;

    .title-input {
      ${titleInput}
    }
  }
`;

export const InputField = styled.input`
  outline: none;
  width: calc(100% - ${containerPadding * 2 + 2}px);
  border: 0;
  background: ${bgColorWhite};
  color: ${colorGray};
  cursor: auto;
  border-radius: 8px;
  box-shadow: ${boxShadowStandard};
  padding: 0.575rem 0.75rem;
  font-size: 1rem;
  line-height: 0.5;
`;

export const InputFieldDay = styled.select`
  outline: none;
  width: 100px;
  border: 0;
  background: ${bgColorWhite};
  color: ${colorGray};
  cursor: pointer;
  border-radius: 10px;
  box-shadow: ${boxShadowStandard};
  padding: 0.755rem 0.95rem;
  font-size: 1rem;
  position: relative;
  line-height: 1.5;
  left: 2px;
`;

export const ButtonContainer = styled.div`
  padding: 10px 0;
  margin: 0px 5px;

  .filterBtn {
    background: #0361a7;
    color: #fff;
    height: 40px;
    width: 200px;
  }
  .filterBtn:hover {
    background: #2e59d9 !important;
    border-color: #2e59d9 !important;
    color: #fff !important;
  }
  .selectService {
    select {
      border-radius: 4px;
      background-color: #0361a7;
      color: #ffff;
      text-align: center;
      border: none;
      width: 240px;
      height: 39px;
      outline: none;
    }
  }
`;

export const SubmitButton = styled.button`
  border-radius: 4px;
  border-style: none;
  box-sizing: border-box;
  color: ${colorWhite};
  cursor: pointer;
  display: inline-block;
  font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-weight: 500;
  width: 200px;
  list-style: none;
  outline: none;
  text-align: center; /* Centraliza o texto */
  text-decoration: none;
  transition: color 100ms;
  vertical-align: baseline;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  background: ${bgColorPadrao};
  box-shadow: ${boxShadowStandard};

  padding: 0.585rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;

  @media only screen and (max-width: 500px) {
    width: 100%;
  }

  &:hover {
    background: #0361a7b3;
  }
`;

export const SubmitButtonAdd = styled.button`
  border-radius: 4px;
  border-style: none;
  box-sizing: border-box;
  color: ${colorWhite};
  cursor: pointer;
  display: inline-block;
  font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-weight: 500;
  width: 200px;
  list-style: none;
  outline: none;
  text-align: center; /* Centraliza o texto */
  text-decoration: none;
  transition: color 100ms;
  vertical-align: baseline;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  background: ${bgColorGreen};
  box-shadow: ${boxShadowStandard};

  padding: 0.585rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;

  @media only screen and (max-width: 500px) {
    width: 100%;
  }

  &:hover {
    background: #008000b5;
  }
`

export const DisplayFlex2 = styled.div`
  display: flex;
  width: 99%;
  padding: 10px;
  border-radius: 8px;
  margin: 0 auto;
  background: var(--toastify-color-light);
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-bottom: 20px;
  border-left: 3px solid #a6a6a6;

  .modalInfo {
    padding: 10px;
    text-align: center;
    width: 100%;
    color: rgb(142, 142, 142);
    font-size: 18px;
  }

  .vlrFat {
    text-align: center;
    font-size: 16px;
  }

  .modalTitle {
    padding: 0 10px;
    width: 50%;
  }

  .title {
    color: ${bgColorPadrao};
    font-size: 18px;
  }

  .subtitle {
    color: #4c4c4c;
    font-size: 14px;
  }

  .container-loading {
    align-items: center;
    justify-content: center;
    display: flex;
    margin: 5px;
  }
`;

export const ButtonBlue = styled.div`
  padding: 10px 20px;
    border-radius: 8px;
    border: none;
    color: #fff;
    background: #0361a7;
    cursor: pointer;
    display: flex;
    font-size: 14px;
    justify-content: center;
    align-items: center;

  &:hover {
    color: #4096ff;
    border: 1px solid #4096ff;
    background: #ffffff;
    transition: 0.2s;
  }
`;

export const ButtonRed = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 30px;
  border-radius: 8px;
  border: none;
  color: #fff;
  background: #e90000;
  cursor: pointer;

  &:hover {
    color: #e90000;
    border: 1px solid #e90000;
    background: #ffffff;
    transition: 0.2s;
  }

  svg {
    font-size: 18px;
  }
`;

export const ButtonBlueService = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 30px;
  border-radius: 8px;
  border: none;
  color: #fff;
  background: #0361a7;
  cursor: pointer;

  &:hover {
    color: #0361a7;
    border: 1px solid #0361a7;
    background: #ffffff;
    transition: 0.2s;
  }

  svg {
    font-size: 18px;
  }
`;

export const BtnUpload = styled.div`
   padding: 10px;
    border-radius: 50px;
    border: none;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    background: var(--toastify-color-warning);
    color: var(--toastify-color-light);
    position: relative;
    top: 10px;
    width: 30px;
    height: 30px;
    margin: 0 auto;
    cursor: pointer;
        display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    &:hover{
      background: #f1c40f94;
    }
`

export const ButtonToclean = styled.button`
  border-radius: 4px;
  border-style: none;

  padding: 0.585rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;

  box-sizing: border-box;
  color: ${colorWhite};
  cursor: pointer;
  display: inline-block;
  font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-weight: 500;
  width: 230px;
  list-style: none;
  outline: none;
  text-align: center; /* Centraliza o texto */
  text-decoration: none;
  transition: color 100ms;
  vertical-align: baseline;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  background: ${bgColorGray};
  box-shadow: ${boxShadowStandard};

  @media only screen and (max-width: 500px) {
    width: 100%;
  }

  &:hover {
    background: #aeaeaebd;
  }
`;

export const NewRegistrationButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3px;
  border-radius: 50px;
  box-shadow: rgb(0 0 0 / 4%) 0px 2px 4px;
  background: ${({ action }) => (action ? bgColorGreen : bgColorGray)};
  position: relative;
  color: #fff;
  font-size: 28px;
  
  width: 45px;
  height: 45px;

  &:hover {
    cursor: pointer;
    background: #0080009c;
  }
`;

export const FindCommand = styled.div`
  border-radius: 8px;
  border-style: none;
  box-sizing: border-box;
  color: ${colorWhite};
  cursor: pointer;
  display: inline-block;
  font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-weight: 500;
  width: 180px;
  list-style: none;
  outline: none;
  text-align: center; /* Centraliza o texto */
  text-decoration: none;
  transition: color 100ms;
  vertical-align: baseline;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  background: ${bgColorGreen};
  box-shadow: ${boxShadowStandard};

  padding: 0.485rem 0.55rem;
  font-size: 1rem;
  line-height: 1.5;

  @media only screen and (max-width: 500px) {
    width: 100%;
  }

  &:hover {
    background: #198754c7;
  }
`;

export const SelectField = styled.select`
  outline: none;
  width: calc(100% - ${containerPadding * 2 + 2}px);
  border: 0;
  background: ${bgColorWhite};
  color: ${colorGray};
  cursor: pointer;
  border-radius: 8px;
  padding: 0.885rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  box-shadow: ${boxShadowStandard};
`;

//TABELAS
export const TableFilter = styled.div`
  width: 50%;
  padding: 10px;
  margin-left: 30px;
  position: relative;
  top: 35px;

  .fieldTitle {
    position: relative;
    top: 20px;
    right: 10px;
    color: #575656;
  }
`;

//O contêiner principal da tabela.
export const TableContainer = styled.div`
  padding: 0;
  margin: 10px;
`;

//O corpo da tabela (onde ficam as linhas e células). aqui eu coloco o scroll-Y

export const TableBody = styled.div`
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 20px;
    transition: opacity 8.5s ease, visibility 6.5s ease;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color:  #fff;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #fff;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: var(--scrollbar-thumb-hover-color, #555);
  }


  .column-adicional{
    padding: 5px;
    text-align: left;
    border-left: 3px solid #0361a7;
    margin-bottom: 15px;
  }

  //essa classe eu só posso usar quando for aplicado o component TableRowOrdemService dentro de TableBody
  .modalContact {
    display: none;
    border-radius: 4px;
    background: #fbf8f8;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    border-left: 3px solid ${bgColorPadrao};
    font-size: 14px;
    font-weight: 300;
    color: #3c3d3e;
    padding: 10px;
    text-align: left;
    position: relative;
    top: -2px;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  }

  .displayFlex{
  display:flex;
      margin-bottom: 5px;
  }

  .padding{
  padding:10px;
  }

  .icon-style{
      box-shadow: rgb(188 188 188 / 20%) 0px 2px 8px 0px;
    color: #4c4a4a;
    border-radius: 8px;
    background: #fff;
    width: 15px;
    height: 15px;
    font-size: 16px;
    border: 1px solid #e9e9e9;
  }

  .modalContact.show {
    display: block;
    opacity: 1;
  }
`;

//serve para mostrar o status da nota, se ela é cancelada ou emitida, deixando uma bolinha com cor para cada status
export const StatusDot = styled.span`
display: inline-block;
width: 6px;
height: 6px;
background-color: ${({ color }) => color || 'gray'};
border-radius: 50%;
margin-right: 8px;
`;


//Cada linha da tabela.
export const TableRow = styled.div`
  display: flex;
  width: 100%;
  border-left: ${({ cancelada }) => cancelada ? '3px solid rgb(255, 39, 39)' : '3px solid #919191'};
  border-radius: 4px;
  height: 90px;
  /*box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;*/
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  margin-bottom: 5px;
  background: ${({ cancelada }) => cancelada ? '#ffdddd' : '#fff'};

  transition: transform 0.3s ease, background 0.3s ease, border-left 0.3s ease;

  &:hover{
    background: ${({ cancelada }) => cancelada ? '#ffabab' : '#e1f1ff'};
    border-left: ${({ cancelada }) => cancelada ? '3px solid rgb(255, 39, 39)' : '3px solid #0361a7'};
    transform: scale(1.02); /* Zoom suave */
    cursor:pointer;
  }
    
  ${TableBody} .column-adicional:hover {
    transform: scale(1.02);
  }
`;

//Essa tabela eu uso no component ORDEM DE SERVIÇO (Muita informação para um component, portanto, irei criar um component que recebe mais informações sem atrapalhar a responsividade)
export const TableRowOrdemService = styled.div`
  display: flex;
  width: 100%;
  border-left: 3px solid #919191;
  border-radius: 4px;
  height: 90px;
  /*box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;*/
box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  margin: 5px 0;
  background: #fff;
  transition: transform 0.3s ease, background 0.3s ease, border-left 0.3s ease;

    &:hover{
  background: #f9f8f8;
    border-left: 3px solid #0361a7;
    transform: scale(1.02); /* Zoom suave */
    cursor:pointer;
  }
`;

//Coluna da tabela.
export const TableColumn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  padding: 10px;
  margin: 5px;
  font-size: 12px;

  .btn-padrao{
  width:20px;
  height: 20px;
  padding: 10px;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    font-size: 25px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    background: #0361a7;
    color: #fff;
    margin: 5px;
  }

  .hover-btn:hover{
  background: #0360a7c4;
  }

  label {
    font-size: 22px;
    color: ${bgColorPadrao};
  }

  .bgBlue {
    background: #0361a7;
    margin: 8px;
  }

  .cancelada {
    background: #ff5656e3;
    color: #fff;
    padding: 5px 10px;
    border-radius: 4px;
  }

  .concluido {
    color: rgb(0 128 0 / 72%);
    padding: 5px 10px;
    border-radius: 4px;
  }

  .inicial {
    background: #005a9ebf;
    color: #fff;
    padding: 5px 16px;
    border-radius: 4px;
  }

  .status-nfe {
    background: #ff5656e3;
    color: #fff;
    padding: 5px 10px;
    border-radius: 4px;
  }

.bolinha {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

/* só a bolinha recebe cor */
.vermelho {
  background-color: #d32f2f;
}

.verde {
  background-color: #388e3c;
}

.cinza {
  background-color: #0361a7;
}

.cinza-claro {
  background-color: #bdbdbd;
}

/* o texto fica limpo */
.texto-situacao {
  font-weight: 500;
  color: #333;
  background-color: transparent;
}


`;

//TITULOS DA TABELA
//primeiro você coloca esse component
export const TableHeader = styled.div`
  padding: 10px;
  margin: 10px;
`;

// aplicar essa como segunda pois ela tem o display flex para ordenar as colunas lado a lado
export const TableHead = styled.div`
  display: flex;
  padding: 0 20px;
`;

//Coluna do titulo
export const ColumnTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  padding: 10px;
  margin: 5px;
  font-size: 10.5px;
`;

//texto do titulo
export const TableTitle = styled.div`
  .span-title {
    font-size: 14px;
    font-weight: 700;
    color: #0361a7;
  }




  .bgBlueAdd{
  background: #0361a7;
  color:#fff;
  }

  .style-color-font-size{
  font-size:12px;
  color: ${bgColorPadrao};
  }
`;

//SELECT
//Criei um select personalizado que vai servir para todos os components que precisar de um selection/option
export const InputSelectOption = styled.input`
  padding: 14px;
  border: none;
  width: 400px;
  border-radius: 8px;
  color: #747070f2;
  box-shadow: rgb(0 0 0 / 4%) 0px 2px 4px;

  &:focus {
    border: none;
    outline: none;
  }
`;

export const ListOptionItem = styled.div`
  position: relative;
  top: 12px;
  height: auto;
  max-height: 200px; /* Define a altura máxima para ativar o scroll */
  overflow-y: auto; /* Ativa o scroll vertical se necessário */
  border-radius: 12px;
  background: #efefefa6;
  padding: 10px;
  font-size: 12px;
  color: #847f7ff2;
  box-shadow: rgb(0 0 0 / 21%) 0px 25px 20px -20px;
  text-align: left;

  .optioninvaalue {
    text-align: center;
    box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
  }

  ul {
    padding: 0;
  }

  li {
    background: rgb(229, 246, 253);
    padding: 10px;
    border-radius: 4px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,
      rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
    margin: 5px 0;
    list-style: none;
  }

  li:hover {
    background: rgb(232 236 238);
    color: black;
    cursor: pointer;
  }
`;

//Usar nos components EVENTOS
export const ContainerFilters = styled.div`
  display: flex;
  width: 100%;
`;

export const InputsFilter = styled.div`
  margin:5px;

  select{
      outline: none;
    color: currentColor;
    padding: 12px;
    font-size: 16px;
    cursor: pointer;
    border-radius: 8px;
    box-shadow: rgb(0 0 0 / 4%) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px;
    border: none;
  }
`;

export const InputFieldFilter = styled.input`
  outline: none;
  color: currentColor;
  padding: 13px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 8px;
  box-shadow: rgb(0 0 0 / 4%) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px;
  border: none;
`;

export const InputSelectFilter = styled.select`
outline: none;
    color: currentColor;
    padding: 13px;
    font-size: 16px;
    cursor: pointer;
    border-radius: 8px;
    box-shadow: rgb(0 0 0 / 4%) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px;
    border: none;
    width: 100%;
`;

export const OptionFilter = styled.option``;


export const InputsDateContainer = styled.div`
display:flex;
  width: 165px;
`;

export const InputDateFilter = styled.div`
width:70px;
margin:5px;
`;

export const InputDate = styled.input`
width:40px;

 outline: none;
  color: currentColor;
  padding: 13px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 8px;
  box-shadow: rgb(0 0 0 / 4%) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px;
  border: none;
      text-align: center;
`;


//checkbox
export const CheckboxContainer = styled.div`
  padding: 2px 30px;
  height: 35px;
  margin: 0px 4px;
  border-radius: 5px;
  background-color: ${(props) => {
    if (props.checked === 'success' || props.checked === 3) return '#008000d6';
    if (props.checked === 'process' || props.checked === 2) return '#0361a7';
    if (props.checked === 'error' || props.checked === 4) return '#ff0000e6';
    if (props.checked === 'fila' || props.checked === 1) return '#f1c40fab';
    return '#fff';
  }};

  display: flex;
  align-items: center;
  box-shadow: rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;
`;

export const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  overflow: hidden;
  white-space: nowrap;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
`;

export const Text = styled.label`
  color: ${(props) => (props.checked ? "#fff" : "#555")};
`;

export const StyledCheckbox = styled.label`
  width: 23px;
  height: 23px;
  margin-right: 15px;
  border-radius: 50%;
  background: #f6f6f6;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    display: ${(props) => (props.checked ? "flex" : "none")};
    filter: invert(75%) sepia(11%) saturate(6042%) hue- rotate(30deg)
      brightness(105%) contrast(68%);
  }
`;

export const ModalConfirm = styled.div`
       width: 240px;
    margin: 5px;
    height: 160px;
    border-radius: 8px;
    position: fixed;
    text-align:center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    background-color: #fff;
    transition: opacity 8.5s ease, visibility 6.5s ease;
    padding: 20px;
    box-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
    overflow-y: auto;
    overflow-x: hidden;
    font-size:14px;

    .displayFlex2{
    display: flex;
    width: 70%;
    margin: 0 auto;
    }

    .padding10{
        padding: 10px;
    }

    .fontSpan{
        font-size: 18px;
    color: #5c5c5c;
    }

    .icon{
    font-size: 22px;
    color: #5c5c5c;
    }


    .btnYes{
    padding: 5px 28px;
    border: none;
    background: #0361a7;
    color: #ffffff;
    border-radius: 4px;
    margin: 2px;
    cursor:pointer;
    }

    .btnNo{
     padding: 5px 28px;
    border: none;
    background: #c8c8c8;
    color: #4d4c4c;
    border-radius: 4px;
    margin: 2px;
    cursor:pointer;
    }

    .btnCancel{
    padding: 5px 10px;
    border: none;
    background: #c8c8c8;
    color: #4d4c4c;
    border-radius: 4px;
    margin: 2px;
    cursor:pointer;
    }
`;

export const ModalBASE64 = styled.div`
  width: 70%;
  margin: 5px;
  height: 570px;
  border-radius: 8px;
  position: fixed;
  text-align: center;
  top: 55%;

  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: #fff;
  transition: opacity 8.5s ease, visibility 6.5s ease;
  padding: 20px;
  box-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset,
    rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
  overflow-y: auto;
  overflow-x: hidden;
  font-size: 14px;

  .form-iframe {
    width: 100%;
    height: 490px;
  }

  .btn-confirm-base-64 {
    padding: 10px;
    margin: 10px;
  }

  .btn-cancel {
    border: 1px solid #4a4a4a;
    color: #4a4a4a;
  }
  .btn-cancel:hover {
    border: 1px solid #7d7d7d!important;
    color: #7d7d7d!important;
  }

  .text-align-right{
  text-align:right;
  }
`;

//Deixa o titulo e o input lado a lado
export const FlexFieldContainer = styled.div`
  display: flex;
  width: 100%;

  .chekPosition {
    display: flex;
    position: relative;
    top: 32px;
  }

  .colWidth {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: 5px;
    font-size: 12px;
  }

  .col {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: 5px;
    font-size: 12px;
  }

  .containerBtnEdit {
        width: 100%;
    text-align: right;
  }

  .btnEdit {
    background: #ffc107;
    color: #fff;
  }

  .btnSalvar{
  width: 100%;
    text-align: right;
  }

  .btnEdit:hover {
    background: #fff;
    color: black !important;
    border: 1px solid #ffc107 !important;
  }

  .inputStyled {
    padding: 5px 10px;
    width: 100%;
  }
    .inputStyled.disabled {
  background-color: transparent;
  color:#717171;
  border: none;
}

.title-input {
      ${titleInput}
    }

  @media only screen and (max-width: 500px) {
    display: block;
  }
`;


export const ButtonEditar = styled.button`
  && {
    background: #fbc00d;
    color: white;
    border: none;
    padding: 8px 25px;
    border-radius: 4px;
    font-size: 14px;
;
    align-items: center;
    cursor:pointer;

    &:hover {
      background:rgb(216, 163, 6);
    }

    &:focus,
    &:active {
      background:rgb(231, 175, 8);
      box-shadow: none;
    }

    &[disabled] {
      background: gray;
      color: #ccc;
      cursor: not-allowed;
    }
  }
`;

export const SkeletonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const LoadingCircle = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid #e0e0e0;
  border-top: 2px solid #999;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const SkeletonBox = styled.div`
  background-color: #e0e0e0;
  border-radius: 4px;
  animation: pulse 1.5s infinite ease-in-out;
  
  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.6; }
    100% { opacity: 1; }
  }
`;

export const BtnSkeleton = styled(SkeletonBox)`
  width: 180px;
  height: 30px;
`;


//Customização de componente do Ent-Designer

export const CustomButton = styled(Button)`
  && {
    background: ${bgColorPadrao};
    color: white;
    border: none;

    &:hover {
      background: ${bgColorHover};
    }

    &:focus,
    &:active {
      background: ${bgColorFocus};
      box-shadow: none;
    }

    &[disabled] {
      background: gray;
      color: #ccc;
      cursor: not-allowed;
    }
  }
`;